<template>
  <button
    type="button"
    class="dropdown-trigger u-clickable"
    @click="$emit('click')"
  >
    <span class="dropdown-trigger__label">
      <slot name="label" :extended="extended">
        <span
          class="font-semibold"
          v-html="extended ? labelExtended : labelShrunk"
        ></span>
      </slot>
    </span>
    <span
      v-if="showIcon"
      class="dropdown-trigger__icon u-flex-shrink-0 u-stroke-deep-current"
    >
      <svg-inline tag="span" :dir="extended ? 'up' : 'down'">
        <icon icon="icon-angle-up" />
      </svg-inline>
    </span>
  </button>
</template>

<script>
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    SvgInline,
    Icon,
  },
  props: {
    extended: {
      type: Boolean,
      default: false,
    },
    labelExtended: {
      type: String,
      default() {
        return this.$t("dropdownTrigger.default.extended");
      },
    },
    labelShrunk: {
      type: String,
      default() {
        return this.$t("dropdownTrigger.default.shrunk");
      },
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".dropdown-trigger";

#{$b} {
  @include mixin.button-reset();
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  color: var.$green-dark;
  transition: var.$transition-default;

  &:hover {
    color: var.$green-hover;
  }

  &__icon {
    width: 16px;
    margin-left: 2px;

    svg {
      transition: var.$transition-default;
    }
  }
}
</style>
